import { AnalysisRenderModeProvider } from "components/AnalysisRenderMode";

export default function EnforceWriteMode({ children }) {
    return (
        <AnalysisRenderModeProvider isReadOnlyMode={false}>
            {children}
        </AnalysisRenderModeProvider>
    );
}